import { render } from "./Main.vue?vue&type=template&id=08b75c74"
const script = {}
script.render = render

export default script